import React from 'react'
import Subheader from '../../../component/Subheader'
import OtherRoom from '../../RoomDetail/OtherRoom';
import RoomBanner from '../../RoomDetail/RoomBanner';
import RoomQuote from '../../RoomDetail/RoomQuote';
import RoomCount from '../../RoomDetail/RoomCount';
import RoomGallery from '../../RoomDetail/RoomGallery';
import RoomEquipment from '../../RoomDetail/RoomEquipment';
import RoomBook from '../../RoomDetail/RoomBook';

export default function RishikeshClub() {
    const heading = "Suite";

    const subheadData = {
        heading: (
                    <>
                    <span className="sr-only">Rishikesh Room</span> {heading}
                    </>
                ),
        breadcrumb: [
            {
                slug: "/resort-de-coracao-rishikesh/room-listing",
                name: (
                        <>
                        <span className="sr-only">{heading}</span> Rooms
                        </>
                    ),
            },
            {
                slug: "",
                name: "Suite",
            },
        ]
    }

    const roomBanner = {
        image: "/image/rishikesh-suite-room-detail.webp",
    };

    const roomQuote = {
        content: "Complete with a Private Balcony and a Large Window, a dedicated wardrobe, and premium in-room amenities, the Suite offers ample space for extended stays or special occasions. Whether you're travelling with family or simply seeking extra room to unwind, this accommodation promises a relaxing stay that's as comfortable as it is memorable.",
    };

    const roomCount = {
        bedroom: "1",
        bedsize: "1 King",
        area: "33",
        bathroom: "1",
        guest: "3",
        balcony: "1"
    };

    const roomGallery = [
        { image: "/image/rishikesh-suite-room-gallery-1.webp" },
        { image: "/image/rishikesh-suite-room-gallery-2.webp" },
        { image: "/image/rishikesh-suite-room-gallery-3.webp" },
        { image: "/image/rishikesh-suite-room-gallery-4.webp" },
    ];

    const roomEquipment = {
        description: "Relax and recharge in a thoughtfully appointed room offering a comfortable atmosphere and convenient modern facilities.",
        equipment: [
        [
            "Premium Pocketed Spring Mattress",
            "Air Conditioning",
            "Complimentary High-Speed Wi-Fi",
            "Smart TV for Entertainment",
        ],
        [
            "Tea & Coffee Maker with Daily Replenishment",
            "Mini Bar for Refreshments",
            "Electronic In-Room Safe",
            "Writing Desk with Comfortable Chair",
        ],
        [
            "Hydropneumatic Shower with 24-Hour Hot Water",
            "Soft Cotton Linens and Plush Duvet",
            "Iron & Ironing Board",
            "Bathrobe & Slippers",
        ]
    ]
    };


    const roomBook = {
        location: "Rishikesh",
        title: "Suite",
        desc: "Experience a spacious and comfortable stay in the Suite at De Coracao, thoughtfully designed for families and extended getaways. With a private balcony, generous interiors, premium amenities, and a dedicated wardrobe, it offers the perfect setting to relax and unwind.",
        details: [
            "1 King Size Bed",
            "Up to 3 Guests",
            "33 sq.mt"
        ],
        enquireLink: "/contact-us",
        bookLink: "https://www.swiftbook.io/inst/#/home?propertyId=682NTPc7dd5tQYOO7KblEIVgpgsly1qSD956Ilzg2MDU=&JDRN=Y&RoomID=255031,255032,255033,255034,255035&ap=1&gsId=682NTPc7dd5tQYOO7KblEIVgpgsly1qSD956Ilzg2MDU="
    };


     const otherRoom = {
        slides: [
            {
                title: 'Super Deluxe',
                bg: '/image/rishikesh-super-deluxe-inner-img.webp',
                slug: '/resort-de-coracao-rishikesh/super-deluxe',
                details: [
                    "1 King Size Bed",
                    "Up to 3 Guests",
                    "26 sq.mt",
                ],
            },

            {
                title: 'Premium Suite',
                bg: '/image/rishikesh-premium-suite-inner.webp',
                slug: '/resort-de-coracao-rishikesh/premium-suite',
                details: [
                    "1 King Size Bed",
                    "Up to 3 Guests",
                    "30 sq.mt",
                ],
            },

            {
                title: 'Ganga Suite',
                bg: '/image/rishikesh-ganga-suite-inner-img.webp',
                slug: '/resort-de-coracao-rishikesh/ganga-suite',
                details: [
                    "1 King Size Bed",
                    "Up to 3 Guests",
                    "30 sq.mt",
                ],
            },
            {
                title: 'Deluxe',
                bg: '/image/rishikesh-deluxe-inner-img.webp',
                slug: '/resort-de-coracao-rishikesh/deluxe',
                details: [
                    "1 King Size Beds",
                    "Up to 2 Guests",
                    "21 sq.mt",
                ],
            },
        ],

        allRoom: { link: "/resort-de-coracao-rishikesh/room-listing" }
    }

    return (
        <>  
            <Subheader subheadData={subheadData} />
            <RoomBanner roomBanner={roomBanner} />
            <RoomQuote roomQuote={roomQuote} />
            <RoomCount roomCount={roomCount} />
            <RoomGallery roomGallery={roomGallery} />
            <RoomEquipment roomEquipment={roomEquipment} />
            <RoomBook roomBook={roomBook} />
            <OtherRoom otherRoom={otherRoom} roomTitle={`${roomBook.location} ${subheadData.heading}`}/>
        </>
    )
}
